module.exports = __webpack_public_path__ + "img/recruit_cont06_img01.533dc2cb.png";